import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledHead = styled.div`
	position: relative;
	display: grid;
	grid-template-columns: 20px 1fr 20px;
	gap: 20px;
	align-items: center;
	padding: 20px;

	${Text} {
		font-weight: 500;
		font-size: 18px;
		text-align: center;
		color: #ffffff;
	}

	img {
		width: 20px;
		height: 20px;
		cursor: pointer;
		opacity: 0.5;
		transition: opacity 0.3s ease;
		user-select: none;
		user-select: none;

		&:hover {
			opacity: 1;
		}
	}
`;

const StyledContainer = styled.div`
	padding: 0 20px;
`;

const StyledPlayersList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

const StyledList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

const StyledOfflineTitle = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	${Text} {
		font-weight: 500;
		font-size: 14px;
		color: #ffffff;
		opacity: 0.25;
	}

	.dot {
		width: 6px;
		height: 6px;
		border-radius: 6px;
		background-color: rgba(255, 255, 255, 0.25);
	}
`;

const StyledNoContactsContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 325px;

	${Text} {
		font-size: 14px;
		color: #ffffff;
		opacity: 0.25;
	}
`;

export {
	StyledContainer,
	StyledHead,
	StyledList,
	StyledNoContactsContainer,
	StyledOfflineTitle,
	StyledPlayersList,
};
